module.exports = __webpack_public_path__ + "img/Ambassadorship@2x.ce3563ad.png";